import { ref } from "vue"

// True while Account Home plays the move-out closure sequence. The nav keeps
// a closed account's items enabled until the sequence reaches that step.
export const isClosureSequencePlaying = ref(false)
